import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { ExportUsersActions } from "store/ducks/settings/users/export-user";
import { exportToCSV } from "utils/exportToCsv";
import { RootState } from "store";

export function useUserExport() {
  const dispatch = useDispatch();

  const { loading } = useSelector((state: RootState) => state.exportUsers);

  const getUserExport = (dataFilter: any = {}) => {
    dispatch(
      ExportUsersActions.request(
        {
          all: true,
          ...dataFilter,
        },
        (data: any[]) => exportToCSV(data, "RELATÓRIO-USUÁRIOS-BAYER")
      )
    );
  };

  return {
    getUserExport,
    exportLoading: loading,
  };
}
